import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from 'react-redux';

function Gallery() {
  const eventData = useSelector((state) => state.event.eventData);
  const gallery = eventData.gallery || [];

  return (
    <div className="overflow-hidden space-bottom">
      <div className="container">
        <div className="title-area text-center">
          <span className="sub-title">Make Your Tour More Pleasure</span>
          <h2 className="sec-title">Recent Gallery</h2>
        </div>
        <div className="row gy-24 gx-24 justify-content-center">
          {gallery.map((item, idx) => (
            <div key={idx} className="col-lg-3">
              <GalleryImage src={item.imageKey} />
            </div>
          ))}
        </div>

        <div className="destination-btn text-center mt-60">
          <Link to="/galleryView" className="th-btn style3 th-icon">
            View All
          </Link>
        </div>
      </div>
    </div>
  );
}

function GalleryImage({ src }) {
  return (
    <div className="gallery-box style2">
      <div className="gallery-img global-img">
        <a href={src} className="popup-image">
          <div className="icon-btn">
            <i className="fal fa-magnifying-glass-plus"></i>
          </div>
          <img src={src} alt="gallery" />
        </a>
      </div>
    </div>
  );
}

export default Gallery;
